import React from 'react'
import {LAYOUT_TYPE_HORIZONTAL} from './Scheduler'

const SchedulerContext = React.createContext({
  layout: LAYOUT_TYPE_HORIZONTAL,
  workDates: {
    start: 8,
    end: 20
  }
})

export default SchedulerContext
